<template>
  <div class="overflow-auto bg-n-surface-1 w-full min-w-0 px-4 md:px-6">
    <div class="max-w-6xl w-full min-w-0 mx-auto pb-24 md:pb-12">
      <router-view />
    </div>
  </div>
</template>
